import { getToken, handleResponse, nextJsonApi } from '@/API/core';

const permissions = {
  getPermissions: async () => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.get('/permissions', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
};

export default permissions;
